<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#FFFFFF"
      d="M35.6,50c2.2,0,4.4-0.2,6.5-0.6c2.2-0.3,4.1-1.3,5.8-3c1.3-1.4,2-3,2-4.7c0-1.1,0-2,0-2.5
      c0-1.1-0.2-1.9-0.2-2.7c-0.3-3.3-0.5-7.1-0.2-11l0.6-9.2c0.2-1.9,0-4.4-0.3-7.4c0-0.6-0.3-1.6-0.6-2.8c-0.5-1.6-1.4-3-2.7-4.1
      c-1.1-0.9-2.4-1.6-3.6-1.7c-0.8,0-1.9-0.2-3.3-0.3h-13c-1.3,0-3.1,0.2-5.8,0.3L10.2,0.6C7.9,0.6,6,1.1,4.4,2c-1.7,0.9-2.7,2.2-3,3.8
      C1.1,6.6,1.1,6.9,1.1,7C0.9,7.6,0.9,8.4,0.8,9.7c-0.2,0.9-0.2,1.9-0.2,2.5L0.8,18C1,20.5,1,22.1,1,22.5c-0.2,4.1-0.3,7.2-0.6,9.1
      C0,33.5,0,36.6,0,41.3C0,42,0.2,42.8,0.3,44c0.3,1.7,1.3,3,2.7,4.1c0.9,0.6,1.9,1.1,2.8,1.3C7.4,49.8,8.7,50,9.4,50
      c3.8,0.2,6.6,0.2,8.5,0H35.6z"
    />
    <path
      fill="#231F20"
      d="M49.8,9.6c0-0.9-0.3-1.9-0.6-3.1c-0.5-1.7-1.4-3.1-2.7-4.4c-1.1-1.1-2.4-1.7-3.8-1.9c-0.6,0-1.7-0.2-3.1-0.3
      H26.5c-0.5,0-1.4,0-2.5,0c-0.9,0-1.7,0-2.4,0.2l-9,0.2c-1.4,0-2.4,0-2.7,0C7.6,0.3,5.6,1,4,1.9c-1.3,0.8-2,1.7-2.4,3
      C1.3,5.5,1.2,6,1.2,6.5c-0.5,2.7-0.6,4.4-0.6,5l0.2,6.1C1,20.4,1,22,1,22.6c-0.2,3.1-0.3,6-0.5,8.1c-0.2,2.2-0.3,5.5-0.2,9.7
      c0,0.8,0.2,1.9,0.3,3.4c0.3,1.3,0.9,2.4,1.9,3.4C3.2,48,4,48.5,4.8,48.9c1.6,0.6,3.1,0.9,4.9,0.9c3.8,0.2,6.5,0.2,8.3,0l17.6-0.2
      c2,0,4.3-0.2,6.6-0.5c2.4-0.3,4.3-1.4,5.8-3.1c1.1-1.4,1.7-2.8,1.7-4.4c0-2.7,0-4.4-0.2-5.2C49,33,49,29.2,49.3,25.1
      c0.2-1.9,0.3-4.7,0.5-8.5C50,14.9,50,12.6,49.8,9.6 M48.4,16.2c-0.2,1.9-0.3,4.5-0.5,8.1c-0.3,4.9-0.2,9.1,0.2,12.5
      c0.2,0.8,0.2,2.4,0.2,4.7c0,1.3-0.5,2.4-1.4,3.6c-1.4,1.4-3,2.4-5,2.7s-4.4,0.5-6.8,0.5H10.3c-0.8,0-2-0.2-3.6-0.5
      c-0.9-0.3-1.9-0.6-2.7-1.3c-1.1-0.8-1.7-1.7-2-3s-0.5-2.4-0.5-3.4V32C2,27,2.1,21.8,2,16.5v-4.7c0-1.3,0.2-3,0.6-5l0.3-1.3
      c0.3-0.9,1.1-1.7,2-2.4c1.4-0.8,2.8-1.3,4.3-1.4c0.9-0.2,1.9-0.2,2.8-0.2h24.6c1.3,0.2,2.5,0.2,3.6,0h1.1c2.2,0.2,3.9,1.1,5.2,3
      c0.9,1.4,1.4,3.1,1.6,4.9C48.4,12.3,48.4,14.4,48.4,16.2z"
    />
    <g id="Cup_2_">
      <path
        fill="#FEC62E"
        d="M35.1,12.6c0,0.6-2,12.2-3.8,14.1c-1.2,1.4-3.3,3.1-6.4,3.1c-3,0-7.2-2.6-8.3-8.5s-1.1-8.2-1.1-8.8
        c0-1,4.6-1.8,11.3-1.8S35.1,11.6,35.1,12.6z"
      />
      <path
        fill="#FEC62E"
        d="M26.4,34.3c1.4-0.4,3.5,0.3,5.1,3c2.6,4.6-4.4,5.3-7.8,5c-3-0.2-8.3-1-7.7-2.7c2-6.1,6-4.7,6-5.3
        c0-1-0.6-5.3,2.3-4.7C27.9,29,25,34.7,26.4,34.3z"
      />
      <path
        fill="#B88F21"
        d="M35.1,11.4c0,1-3.8,1.9-10.2,1.9s-8.5-1-8.5-2.1s4.4-1.8,10.8-1.8S35.1,10.4,35.1,11.4z"
      />
      <path
        fill="#FEC62E"
        d="M35.3,15.1c0,0,2.5-2.4,4.3-1.2s2.5,3.1,0.8,7.3s-9,5.9-9,5.9s0.7-1.4,1.4-3.4c0.4-1,1.6-0.6,2.5-1.4
        c6.9-6.1,0.9-7.3-0.5-4.9C34.5,18,35.2,15.8,35.3,15.1z"
      />
      <path
        fill="#FEC62E"
        d="M15,14.5c0,0-2.2-2.7-4.2,0.2c-1.3,1.9-2.3,2.9-1.1,6.4c1.5,4.3,9,5.9,9,5.9s-0.5-1.1-1.3-3.1
        c-0.4-1-3.1,0.3-5.1-2.8s1.5-6.2,2.9-3.8C15.6,18,15.1,15.6,15,14.5z"
      />
      <path
        d="M41.5,15.7c-0.1-0.6-0.2-1.3-0.9-1.5c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.4-0.4-0.4-0.7-0.5c-0.2-0.1-0.4-0.1-0.6-0.2
        c-1.2-0.5-2.3,0-3.3,0.6c-0.1,0.1-0.2,0.1-0.4,0.2c0-0.1-0.1-0.3-0.1-0.4c0-0.6,0.1-1.3,0.1-1.9c0-0.4,0-0.9-0.3-1.2
        c-0.1-0.1-0.3-0.2-0.5-0.3c-0.4-0.5-1.1-0.6-1.7-0.7c-1-0.2-2.1-0.2-3.2-0.3C29,9.1,28.2,9,27.5,9S26,9,25.3,9.1
        c-0.8,0-1.7,0.1-2.5,0.2c-0.8,0.1-1.7,0.3-2.5,0.4c-0.1,0-0.2,0-0.3,0c-1.4,0-2.8,0.4-4,1c-0.6,0.3-0.7,0.5-0.2,1v0.1
        c-0.7,0.5-0.3,1.5-0.7,2.1c-0.2-0.1-0.4-0.2-0.6-0.3c-1.1-0.5-2.2-0.5-3.2,0.3c-0.8,0.6-1.3,1.3-1.7,2.2c-0.6,1.1-0.9,2.4-0.7,3.7
        c0.4,2.5,1.8,4.3,3.8,5.6c1.6,1,3.2,1.6,5.1,1.8c0.4,0,0.7,0.2,0.9,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.7,0.5,1.3,1,2,1.4
        c0.4,0.3,0.7,0.6,0.7,1.1c0.1,0.9,0.1,1.8,0.1,2.6c0,0.3,0,0.7-0.5,0.7c-1.1,0-2.1,0.5-3,1c-0.6,0.4-1.2,0.8-1.4,1.5
        c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.3,0.5-0.4,0.8c-0.2,0.3-0.3,0.7-0.5,1c-0.2,0.3-0.2,0.5-0.1,0.7c0.4,0.7,0.9,1.2,1.6,1.5
        c1,0.4,2,0.7,3,1c0.6,0.2,1.2,0.4,1.8,0.4c1.1,0.1,2.2,0.1,3.4,0.1c0.1,0,0.3,0.1,0.4,0.1h0.1c0.1,0,0.3-0.2,0.4-0.2
        c0.7,0.1,1.3-0.1,1.9-0.2c1-0.2,2-0.6,2.8-1.3c0.6-0.5,0.9-1.2,1.4-1.7c0.2-0.3,0.1-0.6-0.1-0.9c-0.4-0.6-0.8-1.2-1.2-1.9
        c-0.3-0.5-0.5-1.1-0.8-1.6c-0.5-0.8-1.3-0.9-2.1-1.2c-0.3-0.1-0.7-0.2-1-0.1c-0.3,0.1-0.4,0-0.4-0.3c-0.1-0.5-0.1-1.1-0.1-1.6
        c0-0.5,0.1-1,0.2-1.5c0-0.2,0.1-0.4,0.2-0.7c0.7-0.3,1.4-0.5,2.1-0.8c0.8-0.3,1.5-0.7,1.9-1.5l0.1-0.1c0.6-0.1,1.2-0.3,1.8-0.4
        c0.4-0.1,0.8-0.2,1.2-0.4c1.2-0.6,2.4-1.2,3.6-2c1.2-0.8,2.2-1.7,2.8-3C41.4,19.8,42,17.8,41.5,15.7z M35.1,17.6
        c0.7-0.6,1.4-1.1,2.4-1c0.6,0,0.9,0.5,0.9,1.2c0,0.9-0.4,1.8-1.1,2.4c-0.7,0.7-1.6,1.2-2.4,1.8c-0.3,0.2-0.7,0.4-1,0.7l-0.1-0.1
        c0.1-0.4,0.2-0.7,0.2-1.1c0.2-0.9,0.5-1.9,0.7-2.8C34.8,18.2,34.9,17.8,35.1,17.6z M18.9,10.8c0.8-0.1,1.6-0.3,2.4-0.5
        c0.8-0.1,1.6-0.3,2.5-0.5c-0.2,0-0.5,0-0.7-0.1V9.6c1.4,0,2.9-0.1,4.3-0.1c1.2,0,2.3,0.1,3.5,0.2c0.8,0.1,1.7,0.1,2.5,0.3
        c0.4,0.1,0.8,0.4,1.2,0.6c0.2,0.1,0.3,0.4,0.2,0.7c0,0.3-0.2,0.5-0.6,0.6c-0.7,0.1-1.4,0.2-2.1,0.3c-0.5,0.1-1,0.2-1.5,0.3
        c-1.1,0.1-2.1,0.3-3.2,0.4c-0.6,0-1.3-0.1-1.9-0.1c-0.7,0-1.5,0.1-2.2,0.1s-1.5,0-2.2,0v-0.1c1.7-0.4,3.4-0.6,5.1-0.7
        c-0.5,0-0.9,0-1.4,0s-1,0-1.4,0.1c-1,0.1-2.1,0.3-3.1,0.4c-0.4,0-0.8-0.1-1.2-0.3c1.7-0.5,3.4-0.4,5.1-0.7c-1.1,0-2.1,0.1-3.2,0.1
        c-1,0.1-2.1,0.2-3.1,0.3c0.4-0.4,1-0.4,1.5-0.5c1.7-0.2,3.3-0.5,5-0.7c0.4,0,0.7-0.1,1.1-0.1c-1-0.1-1.9,0.2-2.9,0.2
        c-1,0.1-2,0.2-3,0.3s-1.9,0.2-2.9,0.3C17.3,11.2,18.1,10.9,18.9,10.8z M15.2,17.5c0.3,1.4,0.7,2.8,1,4.2c0.1,0.5,0.3,1,0.5,1.6
        c-0.8-0.2-1.6-0.2-2.2-0.7c-0.9-0.6-1.7-1.4-2.1-2.4c-0.5-1.1-0.4-2.7,1.1-3.5C14.1,16.3,15.1,16.8,15.2,17.5z M16.7,26.1
        c-2.2-0.6-4.2-1.7-5.8-3.5C10.3,21.9,10,21,9.7,20s-0.2-2,0.2-3s0.9-1.9,1.7-2.6c0.3-0.2,0.6-0.4,1-0.5c0,0,0,0.1,0.1,0.1
        c-0.1,0.1-0.2,0.3-0.4,0.5c1-0.4,1.8,0.4,2.6,0.4c-0.9,0-1.7,0-2.5,0c0.8,1,1.6,0.2,2.4,0.4v0.1c-0.7-0.1-1.4-0.1-2.1,0.3
        c0.7,0.2,1.4-0.3,2,0.2V16c-0.3,0-0.5,0-0.8,0c-0.1,0-0.3,0-0.4,0c-0.8,0.4-1.5,1-1.8,1.9c-0.5,1.5,0,2.8,1,4
        c0.1,0.2,0.3,0.3,0.5,0.5c0.7,0.8,1.6,1.4,2.7,1.5c0.4,0,0.8,0.2,1.3,0.4c0.1,0,0.1,0.1,0.1,0.2v0.1h-0.1c-0.7,0-1.4,0.1-2.1,0.1
        v0.1c0.7,0.1,1.4,0.1,2.1,0.2c0.1,0,0.1-0.2,0.2-0.3c0.1,0.2,0.1,0.4,0.2,0.4c-0.9,0-1.7,0-2.5,0v0.2c0.4,0.1,0.9,0.3,1.3,0.4
        c0.3,0,0.6,0.1,0.9,0.1s0.5,0.1,0.6,0.5C17.4,26.2,17,26.2,16.7,26.1z M31.3,38.3c0,0.2,0,0.3,0,0.4c-0.2,0.8-0.8,1.3-1.4,1.7
        c-0.2,0.1-0.3,0.2-0.5,0.4c0.9-0.4,1.6-0.9,2.2-1.7c0,0.1,0,0.3-0.1,0.4c-0.5,0.8-1.2,1.4-2,1.8c-0.5,0.2-1,0.3-1.6,0.4
        c-1,0.1-1.9,0.3-2.9,0.4c-0.9,0.1-1.8,0.1-2.7,0c-0.7-0.1-1.5-0.3-2.2-0.5c-0.8-0.2-1.7-0.5-2.5-0.8c0-0.1,0-0.1,0.1-0.2
        c0.8,0.3,1.7,0.6,2.4,0.5c-0.7-0.2-1.5-0.5-2.4-0.8c-0.4-0.1-0.8-0.3-1.2-0.5v-0.1c0.9,0.2,1.7,0.5,2.6,0.7
        c-0.8-0.5-1.8-0.6-2.6-1.2c0.1-0.2,0.2-0.4,0.4-0.6c0.5,0.7,1.3,1,2.1,1.3c1.1,0.5,2.3,0.7,3.4,0.8c1.6,0.2,3.2,0.1,4.7-0.4
        c0.6-0.2,1.2-0.6,1.9-0.5c0.2,0,0.4-0.2,0.6-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0.1,0.1,0.1c-0.5,0.4-0.9,0.8-1.4,1.2
        C29.7,40.2,30.6,39.4,31.3,38.3z M26.8,35.8c0.3,0.4,0.6,0.5,1,0.6c0.1,0,0.3-0.1,0.4-0.1c0-0.1-0.1-0.3-0.1-0.4
        c-0.2-0.2-0.4-0.4-0.6-0.5c-0.1-0.2-0.3-0.3-0.5-0.5c0.8-0.1,1.4,0.1,2,0.3c0.8,0.4,1.7,2,0.9,2.9c-0.1,0.1-0.2,0.2-0.2,0.4
        C29.6,38.8,29.4,39,29,39c-0.9,0.3-1.8,0.5-2.7,0.8c-0.9,0.3-1.9,0.3-2.9,0.3c-1-0.1-2-0.1-2.9-0.4c-0.9-0.3-1.8-0.6-2.6-1
        c-0.4-0.2-0.6-0.9-0.4-1.6c0.2-0.6,0.6-1.1,1.2-1.4c0.7-0.4,1.4-0.6,2.1-0.9c0.2-0.1,0.4,0,0.7-0.1c-0.2,0.4-0.2,0.8-0.7,0.8
        c-0.4,0.1-0.5,0.4-0.4,0.7s0.4,0.4,0.8,0.3c0,0,0.1,0,0.1-0.1c0.4-0.6,0.9-1.2,1-1.9c0.3-1.3,0.3-2.7,0.1-4c0-0.1,0-0.5,0-0.5
        c1.2,0,2.4,0,3.6,0c-0.2,2-0.2,2.8,0.1,4.1C26.2,34.7,26.5,35.3,26.8,35.8z M20.6,25.6c-0.5,0-1-0.1-1.4-0.1c-0.5,0-0.9-0.3-1-0.8
        c-0.1-0.2-0.1-0.3-0.2-0.5c0.7-0.3,1.4-0.1,2.1-0.3c-0.5,0-1.1-0.2-1.6-0.1c-0.6,0.1-0.8-0.3-1-0.7c-0.1-0.1-0.1-0.3-0.2-0.5
        c0.9-0.2,1.8,0.4,2.5,0c-0.7-0.1-1.4-0.2-2.1-0.3c-0.4,0-0.6-0.3-0.7-0.7c0-0.2-0.1-0.7-0.2-0.7c0.9,0,1.8,0,2.7,0V21
        c-0.6-0.1-1.3,0-1.9-0.1s-1-0.3-1.1-0.9c-0.1-0.3,0-0.3,0.3-0.3c0.7,0,1.3,0,2-0.1c-0.6-0.1-1.2-0.1-1.8-0.2
        c-0.6-0.1-0.8-0.3-0.9-0.9c0-0.2,0-0.3-0.1-0.5c1.2,0.1,2.4,0.2,3.6,0.4c0,0,0,0,0-0.1c-0.5-0.1-1.1-0.2-1.6-0.3
        c-0.3-0.1-0.7-0.1-1-0.2c-0.8-0.1-1-0.3-1.1-1.2c0-0.2,0-0.3,0-0.4c1.2,0.1,2.3,0.3,3.5,0.4v-0.1c-0.8-0.1-1.5-0.3-2.3-0.4
        C16.7,16,16.3,16,16,15.7c-0.3-0.3-0.3-0.5-0.1-0.8c0-0.1,0.1-0.1,0.1-0.2c1.4,0.2,2.7,0.3,4.1,0.5c0,0,0,0,0-0.1
        c-1-0.2-2.1-0.4-3.1-0.5c-0.1,0-0.2,0-0.3-0.1c-1-0.3-1.1-0.6-0.8-1.5l0,0c0.9,0.8,2.1,0.6,3.1,1c0.6,0.2,1.2,0.3,1.9,0.3
        c-0.6-0.1-1.1-0.3-1.7-0.4c-0.7-0.2-1.4-0.4-2.1-0.5c-0.5-0.1-0.9-0.5-1.2-1c0.9,0.2,1.7,0.3,2.4,0.5c1.2,0.4,2.3,0.7,3.6,0.7
        c1.3,0,2.5,0,3.8-0.1c0.9,0,1.9,0,2.8-0.1c1-0.1,2-0.3,3-0.5c1-0.1,2-0.2,3-0.4c0,0.5-0.1,0.9-0.1,1.3c0,0.3,0,0.6,0,0.8
        c0.1,1.1-0.2,2.1-0.5,3.1s-0.5,2.1-0.8,3.1c-0.4,1.8-1.2,3.4-2,5c-0.7,1.3-1.8,2-3.1,2.5c-0.7,0.2-1.4,0.5-2.1,0.6S24.5,29,23.8,29
        c-0.3,0-0.7,0-1,0v-0.1c0.4,0,0.1-0.1,1.1-0.1c0,0,0,0,0-0.1c-1,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.3-0.2s-0.8-0.6-1.1-0.8
        c-0.3-0.3-0.6,0-1-1c1,0,1.9,0,2.8,0l0,0c-0.5,0-1,0.1-1.5,0c-0.7-0.1-1.4-0.2-1.9-0.9c-0.1-0.1-0.1-0.2-0.2-0.4c0.7,0,1.3,0,2,0
        C20.6,25.7,20.6,25.6,20.6,25.6z M40.6,19.4c-0.5,1.8-1.4,3.3-2.9,4.5c-1.3,0.9-2.6,1.6-4,2.2c-0.5,0.2-1,0.4-1.5,0.6
        c0.1-0.4,0.2-0.6,0.3-0.9c0.6,0.3,1.7-0.1,2.7-0.8c-0.4,0.1-0.8,0.2-1.2,0.4c-0.4,0.1-0.8,0.3-1.3,0c0.1-0.2,0.2-0.3,0.2-0.5
        c0.7,0.3,1.4,0.1,2-0.2c0.6-0.3,1.2-0.7,1.8-1.2c-1.2,0.5-2.2,1.4-3.7,1c0.1-0.1,0.2-0.2,0.2-0.2c0.5,0.2,0.9-0.2,1.3-0.4
        c0.6-0.3,1.2-0.7,1.7-1.2c-0.6,0.3-1.2,0.7-1.8,1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0-0.3,0-0.4,0c-0.1-0.1,0-0.2,0-0.4
        c0-0.1,0.1-0.2,0.1-0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0,0.4,0.1,0.5,0c0.9-0.6,1.7-1.3,2.6-1.9c0.9-0.7,1.8-1.6,2.1-2.8
        c0.3-1.2,0.2-2-0.8-2.5c-0.3-0.2-0.7-0.3-1-0.4c0.9-0.4,1.7-0.4,2.4,0.6c0-0.4-0.4-0.8-0.8-0.9c-1-0.2-2,0-3,0.5
        c-0.1,0.1-0.3,0.1-0.4,0.2c0.8-0.8,1.8-1.4,2.8-1.6c-0.7-0.1-1.3,0.3-2,0.5c0.4-0.6,1.1-0.8,1.8-1c-0.1-0.1-0.2-0.1-0.2-0.1
        c0.1,0,0.1,0,0.1,0c0.5,0.1,1,0.1,1.4,0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.4,0.1,0.7,0.4,0.8,0.8C41,16.7,41,18.1,40.6,19.4z"
      />
    </g>
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Progress'
    }
  }
};
</script>
